<div class="pos-panel">
    <div class="pos-new-entity-header">
        <span class="material-icons cyan">trolley</span>
        <span class="soc-panel-h">{{'STOCK_TAKE.NEW_STOCK_TAKE' | translate}}</span>
    </div>
    <hr class="soc-panel-line"/>
    <form  #f="ngForm" [formGroup]="form" class="soc-form-wrapper-gap-24" >
        <div class="pos-actions-wrapper">
                <div class="soc-display-field-wrapper">
                    <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ISSUED_BY' | translate}}</label>
                    <div class="soc-display-field"><span class="soc-display-text">{{stockTake.issuedByUser?.firstName + " " + stockTake.issuedByUser?.lastName}}</span></div>
                </div>
                <div class="soc-display-field-wrapper">
                    <label class="soc-input-lbl w-100 text-start">{{'STOCK_TAKE.ASSIGNED_TO' | translate}}</label>
                    <div class="soc-error-field-wrapper w-100">
                        <span *ngIf="form.controls['assignedTo'].invalid && f.submitted" pTooltip="{{'INFO.REQUIRED_FIELD' | translate}}"  tooltipPosition="top" class="material-icons soc-error-icon" >info</span>
                        <p-dropdown class="soc-dropdown" formControlName="assignedTo" dataKey="id" [filter]="true" [options]="employees"
                        [ngClass]="{'soc-error-active-dropdown': form.controls['assignedTo'].invalid && f.submitted }" 
                        placeholder="{{'SELECT.EMPLOYEE' | translate }}" filterPlaceholder="{{'SEARCH' | translate }}">
                            <ng-template let-employee pTemplate="item">
                                <div>{{employee.firstName}} {{employee.lastName}}</div>
                            </ng-template>
                            <ng-template  pTemplate="selectedItem">
                                <div>{{form.controls['assignedTo'].value.firstName }} {{form.controls['assignedTo'].value.lastName}}</div>
                            </ng-template>
                        </p-dropdown>
                    </div>
                </div>
                
        </div>
        <p-table *ngIf="stockItems" class="soc-borderless-table soc-checkbox-table soc-editable-table" [value]="stockItems" [(selection)]="stockTake.lineItems" (onRowSelect)="onSelect($event)" (onRowUnselect)="onUnselect($event)" [scrollable]="true" scrollHeight="calc(100vh - 462px)">
            <ng-template pTemplate="header">
                <tr>
                    <th [style.max-width]="'48px'">
                    </th>
                    <th [style.max-width]="'138px'">{{'INVENTORY_ITEM.CODE' | translate}}</th>
                    <th [style.max-width]="'380px'">{{'INVENTORY_ITEM.ITEM_NAME' | translate}}</th>
                    <th>{{'INVENTORY_ITEM.UNIT' | translate}}</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item let-rowIndex="rowIndex">
                <ng-container>
                <tr>
                    <td [style.max-width]="'48px'">
                        <p-tableCheckbox [value]="item" [index]="rowIndex"></p-tableCheckbox>
                    </td>
                    <td [style.max-width]="'138px'" class="secondary-td">{{item.item.code}}</td>
                    <td [style.max-width]="'380px'">{{item.item.name}}</td>
                    <td>{{item.item.unitType | unitShortener | lowercase}}</td>
                </tr>
                </ng-container>
            </ng-template>
        </p-table>
        
        <hr class="soc-panel-line"/>
        <div class="soc-wrapper-gap-12 justify-content-end">
            <button class="soc-secondary-cyan-btn" (click)="navigateToMain()">{{'CANCEL' | translate }}</button>
            <button class="soc-basic-cyan-btn" [disabled]="form.controls['items'].errors?.atLeastOne" (click)="issueStockTake()">{{'STOCK_TAKE.ISSUE_STOCK_TAKE' | translate }}</button>
        </div>
    </form>
</div>
<p-confirmDialog class="soc-confirmation-dialog"></p-confirmDialog>
<p-toast position="top-center"></p-toast>
